/**
 * Password Field Component
 * @module patterns/components/form-and-content/fields/password
 */

import { App } from '~/app';

export default (app: App) => {

    app.logger.debug('[Stockland FE] Initialise Stockland Password Field Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountPasswordFormField(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Password Field Component', error);
        });

    return function destroyPasswordFormField() {
        unMountPasswordFormField(listeners);

        app.logger.debug('[DXA] Password Field Component destroyed');
    };
}

// Extracted method for logic reuse within other component
export function mountPasswordFormField(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null) {
    let rootNode: Document | HTMLElement = document;
    if (root)
        rootNode = root;

    const forms = rootNode.querySelectorAll<HTMLElement>('form');

    forms.forEach( form => {
        const passwordFields = form.querySelectorAll<HTMLElement>('.password-input-field');

        passwordFields.forEach( passwordField => {
            const passwordInput = passwordField.querySelector<HTMLInputElement>('input');
            if (!passwordInput?.disabled){
                const togglePasswordButtons = passwordField.querySelectorAll<HTMLElement>('.toggle-password-button div');

                if (togglePasswordButtons && passwordInput){

                    const toggleShowPassword = () => {
                        passwordInput.type === "password" ? passwordInput.type = "text" : passwordInput.type = "password";
                        togglePasswordButtons.forEach( togglePasswordButton => {
                            togglePasswordButton.classList.toggle('hidden');
                        });
                    }

                    togglePasswordButtons.forEach( togglePasswordButton => {
                        togglePasswordButton.addEventListener("click", toggleShowPassword);
                        listeners.push([togglePasswordButton, "click", toggleShowPassword]);
                    });
                }
            }
        });
    });
}

export function unMountPasswordFormField(listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
